import { useEffect, useSyncExternalStore } from 'react';
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { getAuthToken, subscribeToAuth } from '../../utils/authSession';
import Signin from '../auth/Signin';
import InvitationAccept from './InvitationAccept';

const EventJoin = () => {
  const { event_code } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect-to');
  const isEventJoinPage = location.pathname.startsWith('/events/join/');
  const shouldShowInvitation = isEventJoinPage && !redirectTo;
  const authToken = useSyncExternalStore(subscribeToAuth, getAuthToken, () => null);
  const skipUploadLogin = location.pathname.startsWith('/events/upload-join/') && Boolean(authToken);
  const skipDetailLogin = location.pathname.startsWith('/events/detail/') && Boolean(authToken);

  useEffect(() => {
    if (skipUploadLogin) return;
    if (skipDetailLogin) return;

    // Check if URL includes events/join or upload-event-images
    const currentPath = location.pathname;
    const deepLink = ['events/detail', 'events/album'].includes(redirectTo)
      ? `clickapp://${redirectTo}/${encodeURIComponent(event_code)}`
      : currentPath.includes('events/join')
      ? `clickapp://events/join/${event_code}`
      : currentPath.includes('events/detail') 
      ? `clickapp://events/detail/${event_code}` : `clickapp://upload-event-images/${event_code}`;
      console.log("TAKE TO APP")
    // Try opening the app
    window.location.href = deepLink;
        if (shouldShowInvitation || redirectTo) {
      return;
    }
  }, [event_code, location.pathname, redirectTo, shouldShowInvitation, skipUploadLogin, skipDetailLogin]);

  if (skipUploadLogin) {
    if (['events/detail', 'events/album'].includes(redirectTo)) {
      return <Navigate to={`/${redirectTo}/${encodeURIComponent(event_code)}`} replace />;
    }
    return <Navigate to={`/upload-event-images/${encodeURIComponent(event_code)}`} replace />;
  }
  if (skipDetailLogin) {
    return <Navigate to={`/events/detail/${encodeURIComponent(event_code)}`} replace />;
  }

  if (shouldShowInvitation) {
    return <InvitationAccept />;
  }

  return <Signin eventCode={event_code} />;
};

export default EventJoin;
